import {
  getCookie as helperGetCookie,
  removeCookie as helperRemoveCookie,
  setCookie as helperSetCookie,
} from 'helpers/Storage';

const CAN_I_AUTOPLAY = 'CAN_I_AUTOPLAY';
const name = CAN_I_AUTOPLAY;
export const getCookie = () => helperGetCookie({ name });
export const setCookie = value => helperSetCookie({ name, value, options: { path: '/' } });
export const removeCookie = () => helperRemoveCookie({ name });
